import { createContext, useContext } from "react";

// The active frontend template ("classic" | "studio" | "catalog" | "campus" |
// "creator"). Provided high up (CommunityFeed wraps the in-group pages) so shared
// content components — SectionHeader, the views, cards — can adapt their styling
// per template without threading a prop through every call site.
export const TemplateContext = createContext("classic");
export const useTemplate = () => useContext(TemplateContext);
